import { ReactElement } from "react";
import { TextField } from "react-admin";

import { LOCALES } from "../constants";
import { GenericObject } from "../types/generic.types";

const UseLocalizedRAFields = (fields: GenericObject[]): ReactElement<any, any>[] | null => {
  if (!Array.isArray(fields)) return null;

  const resultingElements: ReactElement<any, any>[] = [];

  fields.forEach((field) => {
    LOCALES.forEach((locale) =>
      resultingElements.push(
        <TextField {...field} source={`${field.key}.${locale.key}`} label={`${field.label} (${locale.key})`} />
      )
    );
  });
  return resultingElements;
};

export default UseLocalizedRAFields;
